import { render, staticRenderFns } from "./CustomerTripOrders.vue?vue&type=template&id=19670ece&scoped=true"
import script from "./CustomerTripOrders.vue?vue&type=script&lang=js"
export * from "./CustomerTripOrders.vue?vue&type=script&lang=js"
import style0 from "./CustomerTripOrders.vue?vue&type=style&index=0&id=19670ece&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19670ece",
  null
  
)

export default component.exports